module.exports = __webpack_public_path__ + "img/puberty-decal-04.2afad374.png";